import React, { forwardRef } from "react";
import { useMultiSelectFilterContext } from "../MultiSelectFilter.context";
var MultiSelectFilterInput = forwardRef(function (_a, ref) {
    var placeholder = _a.placeholder, openPopupAndFocusFirstElement = _a.openPopupAndFocusFirstElement, openPopupAndFocusFirstOption = _a.openPopupAndFocusFirstOption, openPopupAndFocusLastOption = _a.openPopupAndFocusLastOption, isPopupOpen = _a.isPopupOpen, closePopup = _a.closePopup, onBlur = _a.onBlur, disabled = _a.disabled;
    var multiSelectModel = useMultiSelectFilterContext().multiSelectModel;
    var numberOfOptionsSelectedLabel = multiSelectModel.getNumberOfOptionsSelectedLabel();
    var onKeyDown = function (event) {
        switch (event.key) {
            case "Tab":
                if (onBlur) {
                    onBlur(event);
                }
                break;
            case "Enter":
            case " ":
                openPopupAndFocusFirstElement(event);
                break;
            case "ArrowDown":
                openPopupAndFocusFirstOption(event);
                break;
            case "ArrowUp":
                openPopupAndFocusLastOption(event);
                break;
        }
    };
    var togglePopup = function (event) {
        if (isPopupOpen) {
            closePopup(event);
        }
        else {
            openPopupAndFocusFirstElement(event);
        }
    };
    return (React.createElement("div", { ref: ref, className: "fr-select ssg-multi-select-filter__input", onClick: togglePopup, onKeyDown: onKeyDown, tabIndex: 0, "aria-disabled": disabled }, numberOfOptionsSelectedLabel ? numberOfOptionsSelectedLabel : placeholder));
});
export default MultiSelectFilterInput;
